// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"218":"component---src-pages-404-tsx","532":"styles","691":"component---src-pages-index-tsx"}[chunkId] + "-" + {"218":"0a5a40872a791bb6d260","532":"00e3a2f5783431e7ce7d","691":"799aa99afb859a3b0fc1"}[chunkId] + ".js";
};